import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { CartContext } from "../CartContext";

const API = "https://ggaarts.onrender.com/api";

const ArtworkDetails = () => {
  const { id } = useParams();
  const [art, setArt] = useState(null);
  const { addToCart } = useContext(CartContext);
  const navigate = useNavigate();

  const [showFull, setShowFull] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/artworks/${id}`)
      .then((res) => setArt(res.data))
      .catch((err) => console.error("Error loading artwork:", err));
  }, [id]);

  if (!art) return <div className="details-loading">Loading...</div>;

  return (
    <div className="details-page">

      {/* IMAGE with FULL VIEW */}
      <div className="details-img-box" onClick={() => setShowFull(true)}>
        <img
          src={art.image}
          className="details-img"
          alt={art.name}
        />
      </div>

      {showFull && (
        <div className="full-image-overlay" onClick={() => setShowFull(false)}>
          <img src={art.image} className="full-image" alt="full" />
        </div>
      )}

      <h1 className="details-title">{art.name}</h1>
      <p className="details-price">₹{art.price}</p>
      <p className="details-description">{art.description}</p>

      {!art.sold && art.category !== "content_creators" && (
        <>
          <button className="details-btn" onClick={() => addToCart(art)}>
            Add to Cart
          </button>

          <button
            className="details-btn checkout-btn"
            onClick={() => navigate("/checkout", { state: { items: [art] } })}
          >
            Place Order
          </button>
        </>
      )}

      {art.sold && <p className="sold-text">SOLD</p>}
    </div>
  );
};

export default ArtworkDetails;
